import { useNavigate } from "react-router-dom";
import { Button, Box } from "@mui/material";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import InfoIcon from "@mui/icons-material/Info";
import MyAccount from "../MyAccount/MyAccount";
import MyDetails from "../MyDetails/MyDetails";

export enum SETTINGS_TAB {
  MY_ACCOUNT = "account",
  MY_DETAILS = "details",
}

interface SettingsProps {
  selectedTab: SETTINGS_TAB;
  parentPath: string;
}

const Settings = ({ selectedTab, parentPath }: SettingsProps) => {
  const navigate = useNavigate();

  const setSelectedTab = (targetTab: SETTINGS_TAB) => {
    const targetUrl = parentPath + "/" + targetTab;
    navigate(targetUrl);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          borderRadius: "10px",
          backgroundColor: "white !important",
          minHeight: "50px",
          paddingX: "1rem",
        }}
      >
        <Box>
          <Button
            startIcon={<ManageAccountsIcon />}
            variant={
              selectedTab === SETTINGS_TAB.MY_ACCOUNT
                ? "customTextSelected"
                : "customText"
            }
            onClick={() => setSelectedTab(SETTINGS_TAB.MY_ACCOUNT)}
          >
            My Account
          </Button>
        </Box>
        <Box>
          <Button
            startIcon={<InfoIcon />}
            variant={
              selectedTab === SETTINGS_TAB.MY_DETAILS
                ? "customTextSelected"
                : "customText"
            }
            onClick={() => setSelectedTab(SETTINGS_TAB.MY_DETAILS)}
          >
            My Details
          </Button>
        </Box>
      </Box>

      {selectedTab === SETTINGS_TAB.MY_ACCOUNT && <MyAccount />}
      {selectedTab === SETTINGS_TAB.MY_DETAILS && <MyDetails />}
    </Box>
  );
};

export default Settings;
